import AbstractComponent from "./abstract-component";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const DURATION = 0.9;
const STAGGER = 0.08;
const EASE = "expo.out";
const Y_FROM = 40;

/**
 * Reveal du contenu des cartes façon Weavenn (c-features_card) :
 * chaque élément interne (titre, icône, description, CTA) monte en cascade,
 * piloté par un stagger GSAP en ordre DOM (carte 1 puis 2 puis 3).
 * Le déclenchement est lié au scroll (ScrollTrigger) pour un vrai flux.
 */
export default class Expertise extends AbstractComponent {
	constructor(el) {
		super(el);
		this.reveals = [...this.$el.querySelectorAll(".js-expertise-reveal")];
		if (!this.reveals.length) return;

		gsap.set(this.reveals, { y: Y_FROM, opacity: 0 });

		// Déjà visible au chargement : on joue tout de suite.
		if (this.$el.getBoundingClientRect().top < window.innerHeight * 0.78) {
			this.play();
			return;
		}

		this.trigger = ScrollTrigger.create({
			trigger: this.$el,
			start: "top 78%",
			once: true,
			onEnter: () => this.play(),
		});
	}

	play() {
		gsap.to(this.reveals, {
			y: 0,
			opacity: 1,
			duration: DURATION,
			ease: EASE,
			stagger: STAGGER,
			clearProps: "transform",
		});
	}

	destroy() {
		this.trigger?.kill();
	}
}
